import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from "react-router-dom";
import Navbar from './components/Navbar';
import { getWebClient, getDataTablesLanguage } from '../helpers/Helpers.js';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';

export default function AdminAnagrafiche({ setAuthenticationToken }) {

    DataTable.use(DT);

    const navigate = useNavigate();

    const columns = [
        { data: 'chiave' },
        { data: 'valore' },
        {
            width: '87px',
            data: 'chiave',
            orderable: false
        }
    ];

    const options = {
        language: getDataTablesLanguage()
    };

    const [tableData, setTableData] = useState([]);   

    function handleDetailsClick(data) {
        navigate(`/impostazioni/${data}`);
    }

    useEffect(() => {

        const client = getWebClient();

        client.get(`/api/impostazioni`)
            .then(function (response) {
                setTableData(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

    }, []);

    return (
        <>

            <link href="https://cdn.datatables.net/v/bs5/dt-2.1.8/datatables.min.css" rel="stylesheet"></link>

            <Navbar setAdminAuthenticationToken={setAuthenticationToken} />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <h4>Impostazioni</h4>
            </div>

            <div className="container" style={{ marginBottom: 80 }}>
                <DataTable data={tableData} columns={columns} options={options} className="table"
                    slots={{
                        2: (data, row) => (
                            <a href={`impostazioni/${data}`} onClick={(ev) => { ev.preventDefault(); handleDetailsClick(data) }}>Dettagli</a>
                        )
                    }}
                >
                    <thead>
                        <tr>
                            <th>Chiave</th>
                            <th>Valore</th>
                        </tr>
                    </thead>
                </DataTable>
            </div>

        </>
    )
}
